import { motion } from "framer-motion";
import "./transition.css";

const Transition = ({mode, setmode,istext="Closed"}) => {
  

  return (
    <div className="ali-toggle" onClick={()=>mode == "0"?setmode("1"):setmode("0")}>
      
      <motion.div
        layout
        layoutId="ali-toggle-bg"
        className="ali-toggle-bg"
        transition={{
          type: "spring",
          stiffness: 420,
          damping: 30,
        }}
        style={{
          left: mode == "0" ? "6px" : "50%",
        }}
      />

      <button
        className={`ali-toggle-btn ${mode == "0" ? "ali-active" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          setmode("0")}}
      >
        <motion.span
          animate={{
            scale: mode == "0" ? 1.08 : 1,
            opacity: mode == "0" ? 1 : 0.8,
          }}
          transition={{ duration: 0.25 }}
        >
          Pending
        </motion.span>
      </button>

      <button
        className={`ali-toggle-btn ${mode == "1" ? "ali-active" : ""}`}
        onClick={(e) => {
           e.stopPropagation();
          setmode("1")}}
      >
        <motion.span
          animate={{
            scale: mode == "1" ? 1.08 : 1,
            opacity: mode == "1" ? 1 : 0.8,
          }}
          transition={{ duration: 0.25 }}
        >
          {istext}
        </motion.span>
      </button>
    </div>
  );
};

export default Transition;